module.exports = __webpack_public_path__ + "media/site_templates/www.roofingcompany.net.au/images/our_services_3-6a5e63dd7344c4c7f9b5bd7a8346b805.jpg";